import React, { useEffect, useState } from 'react'
import { Link, StaticQuery, graphql, withPrefix, navigate } from 'gatsby';
import session from '../../utils/session';

import NavItem from './components/nav-item';
import Dialog from '../dialog'
import API from '../../utils/api'

export default () => {
    const [isOpened, setToggle] = useState(false);
    const [isLoggedIn, setLoggedIn] = useState(false);
    const toggleMenu = (e) => {
        e.preventDefault();

        setToggle(!isOpened);
    };

    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState('')
    const [dialogBody, setDialogBody] = useState('')

    const openedClass = isOpened ? 'nav-active' : '';

    useEffect(() => {
        setLoggedIn(session.isLoggedIn());
    });

    const logoutHandler = () => {
        session.logout();
        setLoggedIn(false);
        setDialogTitle('Logout');
        setDialogBody('You have been succesfully logged out.');
        setShow(true);
    }

    const closeHandler = () => {
        setShow(false);
        navigate('/login');
    }

    const remoteEnterDrawHandler = (e) => {
        e.preventDefault();
        window.location.replace(`${API.baseURL}/skeeball/enter-contest.jsp`)
    }

    return (
        <StaticQuery
            query={graphql`{
                logo1: file(relativePath: {eq: "logoSmall.svg"}) {
                    publicURL
                }
                logo2: file(relativePath: {eq: "newLogo_skeeball.svg"}) {
                    publicURL
                }
            }`}
            render={({ logo1, logo2 }) => {
                const logoUrl1 = withPrefix(logo1.publicURL);
                const logoUrl2 = withPrefix(logo2.publicURL);

                return (
                    <header className={`header position-relative ${openedClass}`}>
                        <div className="position-relative bg-primary pt-7 pb-6 pt-lg-4 pb-lg-2">
                            <div className="container">
                                <div className="row align-items-start">
                                    <div className="col-2">
                                        <div className="ny-logo d-none d-md-block pt-lg-2">
                                            <Link to={withPrefix('/')} className="d-block">
                                                <img className="img-fluid" src={logoUrl1} alt="New York State" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-8 d-flex justify-content-center mb-xl-6">
                                        <div className="logo">
                                            <Link to={withPrefix('/')} className="d-block">
                                                <img className="img-fluid" src={logoUrl2} alt="Skee-ball" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-2 d-none d-lg-flex justify-content-end">
                                        {!isLoggedIn &&
                                        <Link to={withPrefix('/login')} className="login float-right">
                                            LOG IN / REGISTER
                                        </Link>
                                        }
                                        {isLoggedIn &&
                                        <a className="login float-right" onClick={logoutHandler}>
                                            LOG OUT
                                        </a>
                                        }
                                    </div>
                                    <div className="col-2 col-lg-12 d-flex justify-content-end justify-content-lg-center position-static">
                                        <nav className="navbar-hold">
                                            <button onClick={toggleMenu} className="nav-opener" type="button">
                                                <span className="nav-opener-icon"></span>
                                            </button>
                                            <div className="navbar-collapse-hold">
                                                <ul className="navbar-main-nav text-warning list-inline d-lg-flex justify-content-lg-center mb-0">
                                                  <NavItem to={withPrefix('/scratch-game')}>SCRATCH-OFF GAME</NavItem>
                                                  <NavItem to={withPrefix('/play-online-game')}>PLAY FOR FUN</NavItem>
                                                    {API.isLegacyBrowser() &&
                                                    <li className="nav-item undefined">
                                                        <a className="nav-link" href="#" onClick={remoteEnterDrawHandler}>
                                                            <span className="icon-hold"><span className="ball"></span>
                                                                <span className="shadow"></span>
                                                            </span>
                                                            <span className="txt">ENTER DRAW</span>
                                                        </a>
                                                    </li>
                                                    }
                                                    {!API.isLegacyBrowser() &&
                                                  <NavItem to={withPrefix('/enter-contest')}>ENTER DRAW</NavItem>}
                                                  <NavItem to={withPrefix('/drawing-prizes')}>DRAWINGS</NavItem>
                                                  <NavItem to={withPrefix('/winners')}>WINNERS</NavItem>
                                                  <NavItem to={withPrefix('/guidelines')}>GUIDELINES</NavItem>
                                                  <NavItem to={withPrefix('/support')}>SUPPORT</NavItem>
                                                  <NavItem to={withPrefix('/login')} className="d-md-block d-lg-none">LOG IN / REGISTER</NavItem>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Dialog title={dialogTitle} body={dialogBody} show={show} handleClose={closeHandler}/>
                    </header>
                );
            }}
        />
    );
};
